import { format } from "date-fns";

export function getDate(utcDate) {
  if (!utcDate) return "";
  const localDate = new Date(utcDate);
  return format(localDate, "dd/MM/yyyy");
}
